<template>
    <div class="mt-5 mb-0 address-block">

        <address>
            <strong class="pb-4">
                <div class="circleborder icon-addres">
                    <icon-base icon-name="Address" height="41" width="41"><Address /></icon-base>
                </div>
                {{$t('contacte[0].adreça')}}
            </strong>
            <br>
            <br>
                C/ Aneto 16 Nave 4 
            <br>
                50410 Cuarte De Huerva.
            <br>
                Zaragoza 
            <br>
                Tel.: 876 261 010
        </address>
    </div>
</template>

<script>


import Address from '@/assets/svg/Address.vue'
import IconBase from '@/components/elements/IconBase.vue'

export default {
    name: 'tenseFormAddress',
    props: {
    },
    components: {
        IconBase,
        Address
    },
    data () {
      return {
      }
    }
}

</script>

   <!--  border: 10px solid  rgb(234, 95, 8); -->
<style  lang="scss">

.address-block {
    color: grey ;
    z-index: 11;
    padding: 30px;
    margin: 20px 0px 20px 0;
    border: 10px solid #e6e6e6;
    background: #e6e6e6;
    border-radius: 15px;
    z-index: 4;
    position: relative;
    font-size: 1em !important;
}

.icon-addres {
    float: right;
    color: #0f0f0f;
    margin-top: -15px;
    margin-right: -15px;
    display: flex;

    & svg {
        height: 50px !important;
        width: auto;
    }
}
.icon-addres svg {
    height: 50px !important;
    width: auto;
}
</style>